import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { isletmeGirisYap, garsonGirisYap } from '../services/api';

export default function IsletmeLogin() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [kullaniciAdi, setKullaniciAdi] = useState('');
  const [sifre, setSifre] = useState('');
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('isletmeId') && localStorage.getItem('isletmeSlug') === slug) {
      navigate(`/${slug}/ayarlar/panel`);
    }
  }, [slug, navigate]);

  const girisYap = (e) => {
    e.preventDefault();
    setHata(''); setYukleniyor(true);
    isletmeGirisYap(kullaniciAdi, sifre)
      .then((res) => {
        localStorage.setItem('isletmeId', res.data.id);
        localStorage.setItem('isletmeAd', res.data.ad);
        localStorage.setItem('isletmeSlug', res.data.slug);
        localStorage.setItem('isletmeRol', 'MUDUR');
        navigate(`/${res.data.slug}/ayarlar/panel`);
      })
      .catch(() => {
        // Müdür girişi tutmadıysa aynı kullanıcı adı/şifreyle garson girişini dene.
        garsonGirisYap(kullaniciAdi, sifre, slug)
          .then((res) => {
            localStorage.setItem('isletmeId', res.data.id);
            localStorage.setItem('isletmeAd', res.data.ad);
            localStorage.setItem('isletmeSlug', res.data.slug);
            localStorage.setItem('isletmeRol', 'GARSON');
            localStorage.setItem('garsonId', res.data.garsonId);
            localStorage.setItem('garsonAdi', res.data.garsonAdi);
            navigate(`/${res.data.slug}/ayarlar/panel`);
          })
          .catch((err) => setHata(err.response?.data?.hata || 'Giriş yapılamadı.'));
      })
      .finally(() => setYukleniyor(false));
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <form onSubmit={girisYap} className="kart" style={{ width: 340 }}>
        <h2 style={{ marginTop: 0, color: '#1e2a3a' }}>İşletme Yönetim Girişi</h2>
        {hata && <div className="hata-kutu">{hata}</div>}
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Kullanıcı Adı</label>
          <input value={kullaniciAdi} onChange={(e) => setKullaniciAdi(e.target.value)} required />
        </div>
        <div style={{ marginBottom: 18 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Şifre</label>
          <input type="password" value={sifre} onChange={(e) => setSifre(e.target.value)} required />
        </div>
        <button type="submit" disabled={yukleniyor} className="btn btn-vurgu" style={{ width: '100%' }}>
          {yukleniyor ? 'Giriş yapılıyor...' : 'Giriş Yap'}
        </button>
      </form>
    </div>
  );
}
